const pdcsMonth = {
    JAN: 'November, December, January',
    APR: 'February, March, April',
    JUL: 'May, June, July',
    OCT: 'August, September, October',
}

function getKeyByValue(value) {
    for (let key in pdcsMonth) {
        if (pdcsMonth[key].includes(value)) {
            return key;
        }
    }
    return null; 
}

export function getCurrentPCD(pcds){
    const date = new Date()
    const month = date.toLocaleString('en-ES', { month: 'long' });

    return pcds.find((pcd) => pcd.name.includes(getKeyByValue(month))) || pcds[0]
}